import exceptionsTranslations from './Exceptions/Translations';
import preregistrationTranslations from './Preregistration/Translations';

const admissionTranslations = {
  es: {
    preregistration: { ...preregistrationTranslations.es },
    exceptions: { ...exceptionsTranslations.es },
  },
  en: {
    preregistration: { ...preregistrationTranslations.en },
    exceptions: { ...exceptionsTranslations.en },
  }
};

export default admissionTranslations
